import React from "react"
import { Link } from "react-router-dom"
import propTypes from "prop-types"
import "./styles.scss"

const Button = ({ children, link, button, routerLink, className, onClick }) => {
  const getButton = () => {
    let btn = ""
    if (link.href) {
      btn = (
        <a
          className={["btn ", className].join(" ")}
          href={link.href}
          title={link.title}
        >
          {children}
        </a>
      )
    } else if (routerLink.to) {
      btn = (
        <Link
          className={["btn ", className].join(" ")}
          to={routerLink.to}
          title={routerLink.title}
        >
          {children}
        </Link>
      )
    } else if (button.type) {
      if (button.type === "submit") {
        btn = (
          <button
            className={["btn", className].join(" ")}
            disabled={button.disabled}
            type="submit"
          >
            {children}
          </button>
        )
      } else if (button.type === "button") {
        btn = (
          <button
            className={["btn", className].join(" ")}
            disabled={button.disabled}
            type="button"
            onClick={onClick}
          >
            {children}
          </button>
        )
      }
    }
    return btn
  }

  return <div className="btn-wrap">{getButton()}</div>
}

Button.propTypes = {
  children: propTypes.oneOfType([propTypes.node, propTypes.string]),
  className: propTypes.string,
  link: propTypes.shape({
    href: propTypes.string,
    title: propTypes.string
  }),
  routerLink: propTypes.shape({
    to: propTypes.string,
    title: propTypes.string
  }),
  button: propTypes.shape({
    type: propTypes.oneOf(["button", "submit", "reset"]),
    disabled: propTypes.bool
  }),
  onClick: propTypes.func
}

Button.defaultProps = {
  children: "",
  className: "",
  link: {
    href: "",
    title: ""
  },
  routerLink: {
    to: "",
    title: ""
  },
  button: {
    type: "button",
    disabled: false
  },
  onClick: () => {}
}

export default Button
